export default "__VITE_ASSET__ylOI$HVB__"